/*
 * @Author: Dong
 * @Date: 2022-04-20 16:23:48
 * @LastEditors: Dong
 * @LastEditTime: 2022-05-26 09:32:10
 */
import { useState, useEffect } from 'react';
import usePrevious from 'root/common/usePrevious';

const useSuccessStatus = (params: any) => {
  const { status, percent, err, type } = params;
  const prevStatus = usePrevious(status);
  const prevType = usePrevious(type);
  const [successType, setSuccessType] = useState<string>(''); // 成功类型

  // 安装、升级操作，进行中变成成功时，显示成功状态1s中，然后显示版本号
  useEffect(() => {
    if (!['installing', 'upgrading'].includes(prevStatus) || percent || err) return;

    setSuccessType(prevType);

    setTimeout(() => {
      setSuccessType('');
    }, 1000);
  });

  return successType;
};

export default useSuccessStatus;
